import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs } from "../../api/aprvDoc"; // ✅ 결재문서 조회 API
import { formatDate, docStatusMap } from "../../utils/commonUtils";

function RecentAprvDocsCard({
  title = "진행중 결재문서",
  headers = ["제목", "기안자", "기안일"],
  rowKeys = ["title", "user_name", "req_date"],
  limit = 5,
}) {
  const [docs, setDocs] = useState([]);
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const fetchRecentDocs = async () => {
      try {
        // ✅ form_code 구분 없이 전체 진행중 문서 조회
        const { docs: fetchedDocs } = await getDocs(1, limit, "", "request", token);
        setDocs(fetchedDocs);
      } catch (error) {
        console.error("결재문서 불러오기 실패:", error);
      }
    };
    fetchRecentDocs();
  }, [limit, token]);

  return (
    <div className="card mb-3 flex-grow-1">
      <div className="card-body">
        {/* 헤더 영역 */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">{title}</h4>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={() => navigate(`/aprvdoc?page=1&status=request`)}
          >
            더보기
          </button>
        </div>

        {/* 결재문서 목록 */}
        {docs.length === 0 ? (
          <p className="text-muted text-center">진행중 결재문서가 없습니다.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-nowrap align-middle table-hover mb-0">
              <thead className="table-light">
                <tr>
                  {headers.map((h, idx) => (
                    <th
                      key={idx}
                      className={idx === 0 ? "" : "text-center"}
                      style={{ width: idx === 0 ? "40%" : "20%" }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {docs.slice(0, limit).map((doc) => (
                  <tr
                    key={doc.aprv_id}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/aprvdoc/view/${doc.aprv_id}?page=1&status=request`)
                    }
                  >
                    {rowKeys.map((key, idx) => (
                      <td key={idx} className={idx === 0 ? "" : "text-center"}>
                        {key.includes("date") || key.includes("req_date")
                          ? formatDate(doc[key])
                          : key === "doc_status"
                          ? docStatusMap[doc[key]] || doc[key]
                          : doc[key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default RecentAprvDocsCard;